// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JUB3A","option":"styles_option__2blaB","active":"styles_active__1pCa6"};